import { CONFIG_PADRAO, createEngine } from "@caint/engine";

/**
 * Instância única do motor para a UI (config padrão v4.0). Mesmo cálculo do
 * backend — fonte única do IMGQ. A edição de coeficientes (tela Motor) virá no
 * M6 trocando esta config; por ora é fixa.
 */
export const engine = createEngine(CONFIG_PADRAO);
